/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SugestionListAliases {
  APPOINTMENT_SUGGESTION_CARD_SUGGESTIONS_GROUPS_SUGGESTION_LIST = 'appointment-suggestion-card-suggestions-groups-suggestion-list',
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_SORT = 'autocomplete-sort',
  BUTTON_CONFIRM = 'button-confirm',
  CARD_SUGGESTION_ITEM = 'card-suggestion-item',
  CHECKBOX_ONLY_TELECONSULTATION = 'checkbox-only-teleconsultation',
  CONTEXTUAL_BAR_SUGGESTIONS_CONTENT_SUGGESTION_LIST = 'contextual-bar-suggestions-content-suggestion-list',
  DECK_SUGGESTION_GROUPS = 'deck-suggestion-groups',
  DECK_SUGGESTION_ITEMS = 'deck-suggestion-items',
  FIELD_AVAILABLE_DAYS_WEEK_DAYS_SUGGESTION_LIST = 'field-available-days-week-days-suggestion-list',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_SORT = 'field-sort',
  FIELD_TELECONSULTATION = 'field-teleconsultation',
  FILTER_SUGGESTION_TIMES = 'filter-suggestion-times',
  FORM_WEEK_DAYS_FORMULARY_SUGGESTION_LIST = 'form-week-days-formulary-suggestion-list',
  GLOBAL_ACTIONS_ACTION_BUTTONS_SUGGESTION_LIST = 'global-actions-action-buttons-suggestion-list',
  LAYOUT_SUGGESTIONS_CONTENT_SUGGESTION_LIST = 'layout-suggestions-content-suggestion-list',
  LOADER_FILTER = 'loader-filter',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_SORT = 'mapper-sort',
  MAPPER_SUGGESTIONS_SUGGESTION_LIST = 'mapper-suggestions-suggestion-list',
  PANEL_DATE = 'panel-date',
  PANEL_FILTER = 'panel-filter',
  PANEL_FILTERS = 'panel-filters',
  PANEL_LOAD_CONTENT = 'panel-load-content',
  PANEL_SUGGESTIONS = 'panel-suggestions',
  PANEL_SUGGESTIONS_CONTENT = 'panel-suggestions-content',
  PANEL_SUGGESTIONS_CONTENT_SUGGESTION_LIST = 'panel-suggestions-content-suggestion-list',
  PANEL_WEEK_DAYS = 'panel-week-days',
  SEGMENTED_CONTROL_WEEK_DAYS = 'segmented-control-week-days',
  SUGGESTION_LAYOUT = 'suggestion-layout',
  TEXT_DATE_WEEK_DAYS_SUGGESTION_LIST = 'text-date-week-days-suggestion-list',
  TEXT_ESTABLISHMENT_SUGGESTION_LIST = 'text-establishment-suggestion-list',
  TEXT_SORT_SUGGESTION_LIST = 'text-sort-suggestion-list',
}
export { SugestionListAliases };
